import React, { FC, useMemo } from 'react'
import { DeleteIconButton, TextButton } from 'components/Button'
import { Spacer } from 'components/Utility'
import { FlexColumn, FlexRow } from 'components/Flex'
import { SelectBox } from 'components/Form'
import { SelectOption } from 'types/common'
import { StoreType } from 'types/store'

type Props = {
  addStore: () => void
  removeStore: (index: number) => void
  handleStores: (value: string, index: number) => void
  storeIds: string[]
  stores: StoreType[]
}

const StoreSelectForm: FC<Props> = (props) => {
  const { addStore, removeStore, handleStores, storeIds, stores } = props
  const hasNotSelectStore = storeIds.some((storeId) => storeId === '')
  const options = useMemo(() => {
    const storeOptions = stores.reduce((prev: SelectOption[], store: StoreType) => {
      if (!store.store_id) return prev
      // 削除済みの店舗は除外する
      if (store.status === 'deleted') return prev
      return [...prev, { label: store.name, value: store.store_id }]
    }, [])
    return [{ label: '--', value: '' }, ...storeOptions]
  }, [stores])
  return (
    <>
      {storeIds.map((storeId, index) => {
        const select = (value: string) => handleStores(value, index)
        const remove = () => removeStore(index)
        return (
          <React.Fragment key={storeId}>
            <FlexRow justifyContent={'start'}>
              <SelectBox options={options} select={select} value={storeId} />
              <Spacer size={8} />
              <DeleteIconButton onClick={remove} />
              <Spacer size={8} />
            </FlexRow>
            <Spacer size={16} />
          </React.Fragment>
        )
      })}
      <FlexColumn alignItems={'center'}>
        <TextButton
          disabled={hasNotSelectStore}
          iconPath={hasNotSelectStore ? '/icon/grey/plus.svg' : '/icon/blue/plus.svg'}
          label={'店舗を追加する'}
          onClick={addStore}
        />
      </FlexColumn>
    </>
  )
}

export default StoreSelectForm
